<template>
  <div class="container shadow">
    <div class="triangle" />
    <v-list class="list py-5">
      <slot />
    </v-list>
  </div>
</template>

<style scoped>
.container {
  position: relative;
  display: inline-block;
  margin-top: 14px;
  border-radius: 20px;
}
.triangle {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
}
.list {
  border-radius: inherit;
  font-size: 24px;
}
</style>  